// CardStatement
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Wrapper = styled.div`
  color: #fff;
  font-size: 1.4rem;
  background-color: ${props => (props.secondary ? '#5E41A6' : '#436CDE')};
  width: 100%;
  padding: 7vw 10vw;
  margin: 6vw 0;
  margin: ${props => (props.top ? '6vw 0 0 0' : '0 0 6vw 0')};
  @media (min-width: 900px) {
    padding: 9vw 20vw;
  }
`;

function CardStatement({ className = "", ...props }) {
  const classNames = [
    'common-card-statement uk-position-relative uk-box-shadow-medium',
    className,
  ].join(' ');
  return(
    <Wrapper className={ classNames } { ...props }>
      <p className="uk-text-center">
        { props.text }
      </p>
    </Wrapper>
  );
}

CardStatement.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string
};

export default CardStatement;


// WEBPACK FOOTER //
// ./src/features/common/CardStatement.js